export class Item {
    constructor(data, order) {
        this.data = data
        this.order = order
    }

    get id() {
        return this.data.node.id
    }

    get destinationString() {
        const destination = this.order.shippingAddress
        try {
            return destination.address1 + ', ' + destination.city + ', ' + destination.country
        } catch (TypeError) {
            return null
        }
    }

    get vendorAddress() {
        const vendor = this.data.node.vendorData
        return `${vendor.street}, ${vendor.zip} ${vendor.city}, ${vendor.country}`
    }

    get vendor() {
        return this.data.node.vendor
    }

    get name() {
        return this.data.node.name
    }

    get quantity() {
        return this.data.node.fulfillableQuantity
    }

    get unitPrice() {
        return this.data.node.originalUnitPriceSet.shopMoney.amount
    }

    get price() {
        return this.quantity * this.unitPrice
    }

    get currency() {
        return this.data.node.originalUnitPriceSet.shopMoney.currencyCode
    }
}

export class Vendor {
    constructor(name, items, order) {
        this.name = name
        this.items = items
        this.order = order
    }

    get deliveryPrice() {
        const currencies = {
            EUR: '€'
        }
        if (this.deliveryItem) {
            return `${currencies[this.deliveryItem.currency]}${this.deliveryItem.price}`
        } else {
            return 'N/A'
        }
    }

    get productItems() {
        return this.items.filter(item => !item.name.startsWith('Lieferung'))
    }

    get itemsIds () {
        return this.items.map(item => item.id).sort()
    }

    get deliveryItem () {
        return this.items.find(item => item.name.startsWith('Lieferung'))
    }
}

export class Order {
    constructor(data, items) {
        this.data = data
        this.items = items
    }

    get id() {
        return this.data.id
    }

    get name() {
        return this.data.name
    }

    get createdAt() {
        return Date.parse(this.data.createdAt)
    }
}